import { useTranslation } from 'react-i18next'

import { Accordion } from '@/modules/shared/components/accordion/Accordion'
import { QuoteIcon } from '@/modules/shared/icons/QuoteIcon'
import SideNavLink, { SideNavLinkItem } from '@/modules/shared/layouts/side-navigation/SideNavLink'
import { SideBarItem } from '@/modules/shared/layouts/side-navigation/purchaser-navigation/PurchaserNavigation'
import { Themes } from '@/modules/shared/types/Themes'

interface QuotesSideBarItemProps extends SideBarItem {
  quoteRoutesMatch: boolean
}

export const QuotesSideBarItem = ({
  quoteRoutesMatch,
  openAccordionKey,
  changeOpenAccordionKey,
  onCloseDrawer,
  sideBarIndexKey,
}: QuotesSideBarItemProps) => {
  const { t } = useTranslation()

  const getSideNavLinkItems = () => {
    const sideNavItems: SideNavLinkItem[] = []
    sideNavItems.push({
      key: t('general.viewAll', 'View All'),
      target: '/quotes',
    })
    return sideNavItems
  }

  return (
    <Accordion
      titlePrefixIcon={<QuoteIcon className="size-7" />}
      title={t('general.quotes', 'Quotes')}
      activeColor={quoteRoutesMatch ? Themes.Primary : undefined}
      defaultOpen={openAccordionKey === sideBarIndexKey}
      handleTriggerClick={() => changeOpenAccordionKey(sideBarIndexKey)}
      buttonClassName="min-h-11 px-3"
      keepActiveColor
    >
      <SideNavLink
        onCloseDrawer={() => onCloseDrawer()}
        testId="quotes-navigation"
        sideNavLinkItems={getSideNavLinkItems()}
      />
    </Accordion>
  )
}
